import { Dispatch, SetStateAction } from 'react';
import FilterRadioButton from '../../../../components/FilterRadioButtons';
import { FilterRadioButtonsContainer } from '../../../../components/FilterRadioButtonsContainer';
import FormGroup from '../../../../components/FormGroup';
import Input from '../../../../components/Input';
import MyModal from '../../../../components/Modal';
import isEmailValid from '../../../../utils/isEmailValid';
import { ActionTypes } from '../types';

interface IActionsModal {
  actionModalShow: boolean;
  setActionModalShow: Dispatch<SetStateAction<boolean>>;
  selectedAction: ActionTypes;
  setSelectedAction: Dispatch<SetStateAction<ActionTypes>>;
  confirmAction: () => void;
  emailSendZip: string;
  handleEmailSendZipChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function ActionsModal({
  actionModalShow,
  setActionModalShow,
  selectedAction,
  setSelectedAction,
  confirmAction,
  emailSendZip,
  handleEmailSendZipChange,
}: IActionsModal) {
  return (
    <MyModal
      show={actionModalShow}
      title={'Realizar ação com consultas selecionadas'}
      closeButtonLabel="Fechar"
      actionButtonLabel={'Confirmar'}
      onClose={() => setActionModalShow(false)}
      onAction={() => confirmAction()}
      isActionButtonDisabled={selectedAction === 'documentsZip' && (!emailSendZip || !isEmailValid(emailSendZip))}
      type="action"
      modalBody={(
        <>
          <FilterRadioButtonsContainer>
            <FilterRadioButton selected={selectedAction === 'documents'} onClick={() => setSelectedAction('documents')}>
              Download Cartas (PDF Único)
            </FilterRadioButton>
            <FilterRadioButton selected={selectedAction === 'documentsZip'} onClick={() => setSelectedAction('documentsZip')}>
              Download Cartas (ZIP - PDFs Separados)
            </FilterRadioButton>
          </FilterRadioButtonsContainer>

          {selectedAction === 'documentsZip' && (
            <FormGroup>
              <label htmlFor="emailSendZip">Informe um e-mail para ser enviado a URL de download do ZIP.</label>
              <Input
                value={emailSendZip}
                onChange={handleEmailSendZipChange}
                placeholder="email@example.com"
              />
            </FormGroup>
          )}
        </>
      )}
    />
  );
}
